import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import './hero.scss';
import Button from '../Button';
import Div from '../Div';
import VerticalLinks from '../VerticalLinks';

export default function Hero({
  title,
  subtitle,
  text,
  btnText,
  btnLink,
  scrollDownId,
  socialLinksHeading,
  heroSocialLinks,
  bgImageUrl,
  overlay = false,
}) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const defaultImageUrl = '/images/stablerecords/stablerecords-cute.webp';

  useEffect(() => {
    const preloadImages = () => {
      bgImageUrl.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
      setImagesLoaded(true);
    };

    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % bgImageUrl.length);
    }, 10000); // mění obrázek každých 10 sekund

    const preloadTimer = setTimeout(preloadImages, 5000); // načte obrázky po 5 sekundách

    return () => {
      clearInterval(timer); // vyčistí interval při odmontování komponenty
      clearTimeout(preloadTimer); // vyčistí timeout při odmontování komponenty
    };
  }, [bgImageUrl]);

  return (
    <Div className="cs-hero cs-style1 cs-bg cs-fixed_bg cs-shape_wrap_1">
      <Div
        className="cs-hero_background visible"
        style={{ backgroundImage: `url(${defaultImageUrl})` }}
      />
      {imagesLoaded && bgImageUrl.map((url, index) => (
        <Div
          key={index}
          className={`cs-hero_background ${index === currentImageIndex ? 'visible' : 'hidden'}`}
          style={{ backgroundImage: `url(${url})` }}
        />
      ))}
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="container">
        <Div className="cs-hero_text">
          <h1 className="cs-hero_title">{parse(title)}</h1>
          <h4 className="cs-hero_subtitle">{subtitle}</h4>
            <p className="cs-hero_text">{text}</p>
          <Div className="cs-hero_info">
            <Div>
              <Button btnLink={btnLink} btnText={btnText} />
            </Div>
            
          </Div>
        </Div>
      </Div>
      <VerticalLinks data={heroSocialLinks} title={socialLinksHeading} />
      <a href={scrollDownId} className="cs-down_btn">
        .
      </a>
    </Div>
  );
}
